import PostableEditorFooter from "./PostableEditorFooter";

export default PostableEditorFooter;